import React, { useEffect, useState } from 'react'
import { sprintActiveStatus } from '../../ProjectManagement/Service/TaskService';
import Skeleton from 'react-loading-skeleton';

function SprintLifecycle( { projectDetails = [], loading = false }) {

  
  return (
     <>
      {/* {loading ? (
        <Skeleton height={280} width="100%" style={{ marginBottom: "15px" }} />
      ) : ( */}
    <div className="og-card-box">
  <div className="ch-box">
    <i className="ch-icon fa-solid fa-route"></i>
    <h5>Sprint lifecycle</h5>
  </div>

  <div className="cb-box">
    <div className="flow-steps">
    <div className="flow-step">
      <div className="flow-ico sprint-create-icon">
        <i className="fa-solid fa-plus sprint-create-i"></i>
      </div>

      <div className="flow-txt">
        <div className="flow-title">
          Create sprint
        </div>

        <div className="flow-sub">
          Name, goal and dates. Status:
          Planning.
        </div>
      </div>
    </div>

    <div className="flow-step">
      <div className="flow-ico sprint-start-icon">
        <i className="fa-solid fa-play sprint-start-i"></i>
      </div>

      <div className="flow-txt">
        <div className="flow-title">
          Start sprint
        </div>

        <div className="flow-sub">
          Move tasks from Backlog. One
          active at a time.
        </div>
      </div>
    </div>

    <div className="flow-step">
      <div className="flow-ico sprint-pause-icon">
        <i className="fa-solid fa-pause sprint-pause-i"></i>
      </div>

      <div className="flow-txt">
        <div className="flow-title">
          Pause if needed
        </div>

        <div className="flow-sub">
          No new sprint can start while
          paused.
        </div>
      </div>
    </div>

    <div className="flow-step">
      <div className="flow-ico sprint-stop-icon">
        <i className="fa-solid fa-stop sprint-stop-i"></i>
      </div>

      <div className="flow-txt">
        <div className="flow-title">
          Stop or complete
        </div>

        <div className="flow-sub">
          Incomplete tasks return to
          Backlog.
        </div>
      </div>
    </div>

    <div className="flow-step">
      <div className="flow-ico sprint-past-icon">
        <i className="fa-solid fa-box-archive sprint-past-i"></i>
      </div>

      <div className="flow-txt">
        <div className="flow-title">
          Past sprints
        </div>

        <div className="flow-sub">
          Velocity and completion rate
          logged.
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
 {/* )} */}
    </>
  )
}

export default SprintLifecycle